import { createContext, useContext } from 'react';

interface ToastValues 
{
    message         : string;
    setToastMessage : (message? : string) => void;
}

export const initialToastValues = {
    message         : '',
    setToastMessage : () => {}
};

export const ToastContext = createContext<ToastValues>(initialToastValues);

export const useToast = () : ToastValues =>
{
    const context = useContext(ToastContext);
    return context;
};